export function site_url() {
    const prefix = document.body.getAttribute('data-script_name');
    
    let url = Array.prototype.slice.call(arguments);
    
    url.splice(0, 0, prefix);
    
    return url.join('/').replace(/\/{2,}/, '/');
}
